import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';

import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import BooksetHorizontalCard from 'rebook/apps/catalog/components/BooksetHorizontalCard';
import pluralize from 'rebook/apps/utils/text/pluralize';
import BooksetListEmpty from 'rebook/apps/base/components/BooksetListEmpty';

import styles from './style.scss';


const BooksetsCarousel = (
  { booksets, booksetsCount, title, link, linkText, extraClassName }
) => {
  title = typeof title !== 'string'
    ? title
    : (
      <div className="title-2">
        {title}
      </div>
    );
  return (
    <div className={classNames('billetContainerNoOverflow', styles.bookset, extraClassName)}>
      {get(booksets, 'length', 0) > 0
        ? (
          <React.Fragment>
            <div className={styles.title}>
              <div>
                {title}
                {booksetsCount>0 && (
                  <div className={styles.subtitle}>
                    {booksetsCount} {pluralize(booksetsCount, 'подборка', 'подборки', 'подборок')}
                  </div>
                )}
              </div>
              {Object.keys(link).length > 0 && (
                <Link to={link} className={styles.link}>
                  {linkText.length>0 && (
                    <span className={classNames('link', styles.linkText)}>{linkText}</span>
                  )}
                </Link>
              )}
            </div>
            <ContentCarousel>
              {booksets.map((item) => (
                <BooksetHorizontalCard key={`bookset-${item.id}`} bookset={item} />
              ))}
            </ContentCarousel>
          </React.Fragment>
        )
        : (
          <React.Fragment>
            <div className="billetContainerWrapper">
              <div className={styles.titleEmpty} />
              <div className={styles.subTitleEmpty} />
            </div>
            <div className={styles.booksetListEmpty}>
              <BooksetListEmpty />
            </div>
          </React.Fragment>
        )
      }
    </div>
  );
};

BooksetsCarousel.propTypes = {
  booksets: PropTypes.array,
  booksetsCount: PropTypes.number,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  link: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  linkText: PropTypes.string,
};

BooksetsCarousel.defaultProps = {
  booksets: [],
  booksetsCount: 0,
  title: null,
  link: '',
  linkText: '',
};

export default BooksetsCarousel;
